<div *ngIf="hasSelectedFile" class="selected-files">
  <p class="selected-file-item">
    <span class="selected-file-name" title="{{ fileName }}">{{ fileName }}</span>

    <i id="btn-remove-file" class="fas fa-times" (click)="resetFiles()"></i>
  </p>
</div>

<input
  #fileField
  id="upload-file-field"
  type="file"
  placeholder="Upload AML"
  accept="{{ acceptedFiles }}"
  (change)="newFile($event)"
  class="hide"
/>

<button
  type="button"
  id="btn-upload-aml"
  class="btn-primary has-icon"
  [ngClass]="{ active: hasSelectedFile }"
  (click)="fileField.click()"
  title="Accepted extension(s): {{ acceptedFiles }}"
  [disabled]="disabled"
>
  <i class="fas fa-file-upload"></i>
  Import file
</button>
